<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    function login() {
        dispatch('credentials', {
            uname: event.target.uname.value,
            pwd: event.target.pwd.value
        });
    }
    function validate() {
          console.log(event);
      console.log(event.target);
        console.log(event.target.uname.value);
        console.log(event.target.pwd.value);
    }


</script>

<form on:submit|preventDefault={login}>
    <label for="uname">Username:</label><br>
  <input type="text" id="uname" name="uname" value="gifftest1@teamhat.com"><br>
  <label for="pwd">Password:</label><br>
  <input type="text" id="pwd" name="pwd" ><br><br>
  <input type="submit" value="Login">

</form>